import baseInitState from "../baseInitState";
import {actionType} from "../../actions/provider-channel";
import baseReducer from "../baseReducer";

const initState = {
    ...baseInitState,
};

export default function reducer(state = initState, action: any) {
    switch (action.type) {
        case actionType('action').success: //example action
            return {
                ...state,
            };

        default:
            return baseReducer(state, action, actionType);
    }
}
